export const content = {
  fr: {
    nav: {
      about: "À propos",
      services: "Activités",
      values: "Valeurs",
      vision: "Vision",
      contact: "Contact",
      cta: "Nous contacter",
    },
    hero: {
      overline: "Immobilier d'exception · Panafricain",
      title1: "Nous ne vendons pas",
      title2: "seulement des biens,",
      titleAccent: "nous créons des lieux de vie exceptionnels.",
      slogan: "Votre confiance, notre engagement",
      cta1: "Découvrir nos activités",
      cta2: "Prendre rendez-vous",
      scroll: "Défiler",
    },
    about: {
      overline: "Identité de marque",
      title: "Bâtir aujourd'hui, valoriser demain",
      p1: "A&A Immobiliers est une entreprise panafricaine spécialisée dans la vente de biens immobiliers, la restauration de bâtiments, la location et la gestion immobilière.",
      p2: "Nous construisons plus que des espaces, nous bâtissons des héritages.",
      stats: [
        { value: "100%", label: "Confiance client" },
        { value: "4", label: "Pôles d'expertise" },
        { value: "Afrique", label: "Présence panafricaine" },
      ],
    },
    services: {
      overline: "Nos activités",
      title: "Une expertise immobilière à 360°",
      subtitle: "De la transaction à la gestion, nous vous accompagnons à chaque étape de votre projet.",
      items: [
        {
          icon: "Home",
          title: "Vente de biens immobiliers",
          desc: "Maisons, terrains, appartements, immeubles… Trouvez le bien qui correspond à vos ambitions.",
        },
        {
          icon: "Key",
          title: "Location",
          desc: "Des solutions de location flexibles et sécurisées pour particuliers et entreprises.",
        },
        {
          icon: "Paintbrush",
          title: "Restauration de bâtiments",
          desc: "Redonnons vie à vos bâtiments avec qualité, passion et durabilité.",
        },
        {
          icon: "Building2",
          title: "Gestion immobilière",
          desc: "Gestion locative, suivi technique, administratif et rentabilité optimisée.",
        },
      ],
    },
    values: {
      overline: "Nos valeurs",
      title: "Ce qui nous guide",
      items: [
        { icon: "ShieldCheck", title: "Confiance" },
        { icon: "Gem", title: "Excellence" },
        { icon: "Users", title: "Intégrité" },
        { icon: "Leaf", title: "Durabilité" },
        { icon: "Lightbulb", title: "Innovation" },
      ],
    },
    vision: {
      overline: "Vision & Mission",
      visionTitle: "Notre Vision",
      visionText: "Être la référence immobilière en Afrique en créant de la valeur durable et des espaces qui transforment les vies.",
      missionTitle: "Notre Mission",
      missionText: "Offrir des solutions immobilières innovantes, fiables et durables, centrées sur les besoins de nos clients et l'excellence du service.",
    },
    contact: {
      overline: "Contact",
      title: "Construisons votre projet ensemble",
      subtitle: "Une question, un projet ? Notre équipe vous répond avec attention.",
      infoTitle: "Informations",
      address: "Riviera Mbadon",
      phone: "07 89 88 00 88",
      email: "sales@2aimmob.com",
      form: {
        name: "Nom complet",
        email: "Adresse e-mail",
        phone: "Téléphone",
        subject: "Sujet",
        message: "Votre message",
        submit: "Envoyer le message",
        sending: "Envoi en cours...",
        success: "Merci ! Votre message a bien été envoyé.",
        error: "Une erreur est survenue. Veuillez réessayer.",
      },
    },
    footer: {
      tagline: "Votre confiance, notre engagement",
      slogan: "Bâtir aujourd'hui, valoriser demain.",
      rights: "Tous droits réservés.",
      nav: "Navigation",
      contact: "Contact",
    },
  },
  en: {
    nav: {
      about: "About",
      services: "Services",
      values: "Values",
      vision: "Vision",
      contact: "Contact",
      cta: "Get in touch",
    },
    hero: {
      overline: "Exceptional Real Estate · Pan-African",
      title1: "We don't just",
      title2: "sell properties,",
      titleAccent: "we create exceptional places to live.",
      slogan: "Your trust, our commitment",
      cta1: "Explore our services",
      cta2: "Book an appointment",
      scroll: "Scroll",
    },
    about: {
      overline: "Brand identity",
      title: "Build today, grow tomorrow",
      p1: "A&A Immobiliers is a pan-African company specialized in property sales, building restoration, rentals and real estate management.",
      p2: "We build more than spaces, we build legacies.",
      stats: [
        { value: "100%", label: "Client trust" },
        { value: "4", label: "Areas of expertise" },
        { value: "Africa", label: "Pan-African presence" },
      ],
    },
    services: {
      overline: "Our services",
      title: "End-to-end real estate expertise",
      subtitle: "From transaction to management, we support you at every step of your project.",
      items: [
        {
          icon: "Home",
          title: "Property Sales",
          desc: "Houses, land, apartments, buildings… Find the property that matches your ambitions.",
        },
        {
          icon: "Key",
          title: "Rentals",
          desc: "Flexible and secure rental solutions for individuals and businesses.",
        },
        {
          icon: "Paintbrush",
          title: "Building Restoration",
          desc: "We bring your buildings back to life with quality, passion and durability.",
        },
        {
          icon: "Building2",
          title: "Property Management",
          desc: "Rental management, technical and administrative monitoring, optimized profitability.",
        },
      ],
    },
    values: {
      overline: "Our values",
      title: "What guides us",
      items: [
        { icon: "ShieldCheck", title: "Trust" },
        { icon: "Gem", title: "Excellence" },
        { icon: "Users", title: "Integrity" },
        { icon: "Leaf", title: "Sustainability" },
        { icon: "Lightbulb", title: "Innovation" },
      ],
    },
    vision: {
      overline: "Vision & Mission",
      visionTitle: "Our Vision",
      visionText: "To be the real estate reference in Africa by creating lasting value and spaces that transform lives.",
      missionTitle: "Our Mission",
      missionText: "To deliver innovative, reliable and sustainable real estate solutions, centered on our clients' needs and service excellence.",
    },
    contact: {
      overline: "Contact",
      title: "Let's build your project together",
      subtitle: "A question, a project? Our team will respond with care.",
      infoTitle: "Information",
      address: "Riviera Mbadon",
      phone: "07 89 88 00 88",
      email: "sales@2aimmob.com",
      form: {
        name: "Full name",
        email: "Email address",
        phone: "Phone",
        subject: "Subject",
        message: "Your message",
        submit: "Send message",
        sending: "Sending...",
        success: "Thank you! Your message has been sent.",
        error: "Something went wrong. Please try again.",
      },
    },
    footer: {
      tagline: "Your trust, our commitment",
      slogan: "Build today, grow tomorrow.",
      rights: "All rights reserved.",
      nav: "Navigation",
      contact: "Contact",
    },
  },
};
